import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const getUserTicketsService = async (userToken: string) => {
  return axiosV3.get("/user/ticket", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
